import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-switch-wrap" }
const _hoisted_2 = { class: "seg seg-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchToAdmin())),
        class: _normalizeClass(_ctx.$store.state.user.isAdmin ? 'on' : '')
      }, "Admin", 2),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchToPublic())),
        class: _normalizeClass(_ctx.$store.state.user.isAdmin ? '' : 'on')
      }, "Standard", 2)
    ])
  ], 512)), [
    [_vShow, _ctx.$store.state.user.userToPublic]
  ])
}